import Vue from 'vue'
import { decode } from '@/lib/util'
import '../carousel-swiper/carousel-swiper.vue'

export default el => new Vue({
  el
})